import { CommonModule } from '@angular/common';
import { Component, computed, EventEmitter, Output } from '@angular/core';

import { CustomInputComponent } from '../../custom-input/custom-input.component';
import { CommonService } from '../../../services/common.service';
import { OutsideClickDirective } from '../../../directives/outside-click.directive';
import { FilterService } from '../../../services/filter.service';
import { FilterRequest } from '../../../shared/types';
import { transformTestToFilters } from '../../../shared/appUtil';
import { NotificationService } from '../../../services/notification.service';
import { LabelService } from '../../../services/label.service';
import { ConfirmPopupService } from '../../../services/confirm-popup.service';
import { PopupConfirmationData } from '../../../shared/constant';

@Component({
  selector: 'filter-save-dropdown',
  standalone: true,
  imports: [CommonModule, CustomInputComponent, OutsideClickDirective],
  templateUrl: './filter-save-dropdown.component.html',
  styleUrl: './filter-save-dropdown.component.scss',
})
export class FilterSaveDropdownComponent {
  constructor(
    private commonService: CommonService,
    private filterService: FilterService,
    public notificationService: NotificationService,
    private labelService: LabelService,
    private confirmPopupService: ConfirmPopupService
  ) {}
  protected _savedButtonEnabled = computed<boolean>(() => this.filterService.saveButtonEnabled());
  dropdownOpened: boolean = false;
  labelPopupOpened: boolean = false;
  saveDisabled: boolean = true;
  labelText: string = '';
  savedLabelText: string = '';
  filter_save: any = {};

  @Output() onSaveFilters = new EventEmitter<void>();

  ngOnInit() {
    this.filterService.getSavedFilterLabel().subscribe((label) => {
      this.savedLabelText = label;
    });
    this.labelService.getJsonData().subscribe((data) => {
      this.filter_save = data?.filter_save ?? {};
    });
  }

  toggleMoreDropdown = () => {
    this.dropdownOpened = !this.dropdownOpened;
    if (this.labelPopupOpened) {
      this.labelPopupOpened = false;
    }
  };

  toggleLabelDropdown = () => {
    this.labelPopupOpened = !this.labelPopupOpened;
  };

  handleCancelPress = (event: MouseEvent) => {
    this.labelPopupOpened = false;
    event?.stopPropagation();
  };

  handleSavePress = (event: MouseEvent) => {
    const requestData = {
      tag: this.savedLabelText,
      filter: { filter: this.populateFilteredData() },
    };
    if (requestData.filter.filter.length) {
      this.commonService.updateFilters(requestData).subscribe({
        next: () => {
          this.filterService.updateSavedFilterList(
            {
              ...requestData,
              updated_at: '',
            },
            true
          );
          this.filterService.setSavedButtonEnabled(false);
          this.notificationService.success('Save filter', 'Filter saved');
        },
      });
      this.toggleMoreDropdown();
    } else {
      this.notificationService.error('Error saving filter', 'Filters cannot be empty');
    }

    event?.stopPropagation();
  };

  populateFilteredData(): FilterRequest[] {
    const filterDataArray = this.filterService.getFilterConditionDataValue();
    const { data, error } = transformTestToFilters(filterDataArray);
    const filteredData: FilterRequest[] = [...data];
    if (error) {
      // this.notificationService.error('Error in filters', 'Error in filters');
    }
    return filteredData;
  }

  handleSaveAsNewPress = (event: MouseEvent) => {
    const requestData = {
      tag: this.labelText,
      filter: { filter: this.populateFilteredData() },
    };

    if (requestData.filter.filter.length) {
      this.commonService.saveFilters(requestData).subscribe({
        next: () => {
          this.filterService.setSavedFilterLabel(this.labelText);
          this.filterService.updateSavedFilterList({
            ...requestData,
            updated_at: '',
          });
          this.filterService.setSavedButtonEnabled(false);
          this.notificationService.success('Save filter', 'Filter saved');
        },
      });

      this.toggleMoreDropdown();
    } else {
      this.notificationService.error('Error saving filter', 'Filters cannot be empty');
    }

    event?.stopPropagation();
  };

  handleDeleteFilter = (event: MouseEvent) => {
    const requestData = {
      tag: this.savedLabelText,
    };

    if (requestData.tag.length) {
      this.confirmPopupService.openConfirmDialog(PopupConfirmationData.deleteConfirmation).subscribe((result) => {
        if (result === true) {
          this.commonService.deleteFilter(requestData).subscribe({
            next: () => {
              this.filterService.removeFilterFromList(requestData.tag);
              this.filterService.setSavedButtonEnabled(false);
              this.notificationService.success('Delete filter', 'Filter deleted');
            },
            error: (error) => {
              this.notificationService.error('Error deleting filter', 'Failed to delete filter');
            }
          });
          this.toggleMoreDropdown();
        }
      });
    } else {
      this.notificationService.error('Error deleting filter', 'No saved filter to delete');
    }

    event?.stopPropagation();
  };

  stopPropagation = (event: MouseEvent) => {
    event?.stopPropagation();
  };

  onOutsideClick = () => {
    this.toggleMoreDropdown();
  };

  handleInputChange = (input: string) => {
    this.labelText = input;
  };
}
